function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "People"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 32,
  "data-height": 15,
  transform: "translate(0 8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.259 11.432c.088-.262.085-.451-.037-.442-.074.006-.147.009-.222.009-1.177 0-2.263-.616-3.074-1.601-.176-.213-.328-.399-.363-.399h-.063c-1.933 0-3.5 1.567-3.5 3.5v1c0 .276.224.5.5.5h6c.276 0 .5-.224.5-.5v-.5c0-.549.093-1.074.259-1.568z",
  className: "iconic-people-person iconic-people-person-body iconic-people-person-left iconic-people-person-body-left iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 5.25c0 2.485-1.567 4.75-3.5 4.75s-3.5-2.265-3.5-4.75 1.567-4.25 3.5-4.25 3.5 1.765 3.5 4.25z",
  className: "iconic-people-person iconic-people-person-head iconic-people-person-left iconic-people-person-head-left iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.437 9c-.035 0-.187.186-.363.399-.811.985-1.898 1.601-3.074 1.601-.074 0-.148-.003-.222-.009-.122-.009-.126.18-.037.442.166.493.259 1.019.259 1.568v.5c0 .276.224.5.5.5h6c.276 0 .5-.224.5-.5v-1c0-1.933-1.567-3.5-3.5-3.5 0 0-.028 0-.063 0z",
  className: "iconic-people-person iconic-people-person-body iconic-people-person-right iconic-people-person-body-right iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 5.25c0 2.485-1.567 4.75-3.5 4.75s-3.5-2.265-3.5-4.75 1.567-4.25 3.5-4.25 3.5 1.765 3.5 4.25z",
  className: "iconic-people-person iconic-people-person-head iconic-people-person-right iconic-people-person-head-right iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.765 9c-.13 0-.366.181-.548.39-.845.971-1.947 1.61-3.217 1.61s-2.372-.639-3.217-1.61c-.181-.208-.418-.39-.548-.39h-.235c-2.209 0-4 1.791-4 4v1.5c0 .276.224.5.5.5h15c.276 0 .5-.224.5-.5v-1.5c0-2.209-1.791-4-4-4 0 0-.105 0-.235 0z",
  className: "iconic-people-person iconic-people-person-body iconic-people-person-center iconic-people-person-body-center iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 4.5c0 2.761-1.791 5.5-4 5.5s-4-2.739-4-5.5 1.791-4.5 4-4.5 4 1.739 4 4.5z",
  className: "iconic-people-person iconic-people-person-head iconic-people-person-center iconic-people-person-head-center iconic-property-fill"
}));

function SvgPeopleMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "people",
    className: "iconic iconic-people iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleMd);
export default __webpack_public_path__ + "static/media/people-md.e051b2f7.svg";
export { ForwardRef as ReactComponent };